import MenuItem from "./../../../core/components/menu/MenuItem";
import i18n from '../../../shared/i18n'
import SettlementPayments from "@/modules/finance/settlement-payments/SettlementPayments";

let routes = [{
  path: 'settlement-payments',
  name: 'settlementPayments',
  component: SettlementPayments,
  meta: {
    requiresAuth: true
  }
}];

export default {
  menuItem: new MenuItem('/settlement-payments', i18n.t('Sett. Payments'), 41, 'wallet', [], 'view_settlement'),
  routes: routes
}
